// DS: PO28
/** Popup prompting users to verify their email address */
import React, { useContext, useCallback } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { VerificationRequiredActions } from '../publicSession/types';
import { FirstTimeFlag, DropFirstTimeFlagPayload } from '../redux/firstTimeFlags';
import VerificationPopupDesktop from './VerificationPopupDesktop';
import VerificationPopupMobile from './VerificationPopupMobile';

export interface Props {
  actionType?: VerificationRequiredActions;
  email: string;
  dropFlagOnClose?: boolean;
  dropFirstTimeFlag: (payload: DropFirstTimeFlagPayload) => void;
  isSendingDone?: boolean;
  changeEmail: () => void;
  resendEmail: () => void;
  onClose?: () => void;
}

export const VerificationPopup: React.FC<Props> = ({
  dropFlagOnClose,
  dropFirstTimeFlag,
  onClose,
  ...props
}) => {
  const isMobile = useContext(MobileContext);
  const handleClose = useCallback(() => {
    if (dropFlagOnClose) {
      dropFirstTimeFlag({
        flag: FirstTimeFlag.WelcomePopupNotClosed,
      });
    }
    return onClose && onClose();
  }, [dropFlagOnClose, dropFirstTimeFlag, onClose]);

  return isMobile ? (
    <VerificationPopupMobile onClose={handleClose} {...props} />
  ) : (
    <VerificationPopupDesktop onClose={handleClose} {...props} />
  );
};
VerificationPopup.displayName = 'VerificationPopup';

export default VerificationPopup;
